// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_37QWe","inner":"style_inner_1iBFs"};